import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {FormDialog, FormDialogDefinition} from '@aviary/dialogs/form-dialog/form-dialog.types';
import {ChangePatronEmailValue} from '@store/patron/patron.types';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {ExtendedFormBuilder} from '@aviary/forms/extensions/extended-form-builder/extended-form-builder';
import {Validators} from '@angular/forms';
import {FormDialogComponent} from '@aviary/dialogs/form-dialog/form-dialog.component';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';

export interface ChangeEmailDialogData {
  email: string;
}

@Component({
  selector: 'px-change-email',
  template: `
    <mx-form-dialog [definition]="dialogDefinition">
      <div class="flex flex-col">
        <p class="text-title-large">Current Email</p>
        <p class="text-body-large">{{ dialogData.email }}</p>
      </div>
      <mx-input-form-field fieldName="email" placeholder="example@example.com" [formGroup]="formGroup"/>
    </mx-form-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormDialogComponent, InputFormFieldComponent]
})
export class ChangeEmailDialog implements FormDialog<ChangeEmailDialogData, ChangePatronEmailValue> {

  public readonly dialogData: ChangeEmailDialogData = inject(MAT_DIALOG_DATA);
  public readonly formGroup: ExtendedFormGroup = inject(ExtendedFormBuilder).nonNullable.extendedGroup({
    email: ['', {validators: [Validators.required]}]
  });
  public readonly statelessSelectors = CatalogSelectors.Stateless;

  public readonly dialogDefinition: FormDialogDefinition<ChangePatronEmailValue> = {
    title: 'Change Email',
    prompt: 'Once submitted, you will receive an email to verify your email address. You’ll need the click the link in your email to complete the change.',
    confirmButtonLabel: 'Send Verification Email',
    formGroup: this.formGroup
  };
}
